import React from "react";
import { Link } from "react-router-dom";

const HomeCarousel = () => {
  const userToken = JSON.parse(localStorage.getItem("WM:user-token"));

  return (
    <>
      <div className="container h-full mx-auto px-4 py-14 sm:px-6 xl:px-12">
        <div className="flex flex-col items-center justify-center space-y-6 text-center">
          <h1 className="text-4xl font-bold tracking-normal sm:text-5xl lg:text-6xl">
            Welcome to the Write-Me
          </h1>
          <p className="max-w-screen-sm text-lg text-gray-600 sm:text-2xl">
            Express your ideas and feelings through writing.
          </p>
          <form className="flex w-full max-w-md flex-col justify-center items-center space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3">
            {userToken ? (
              <div>
                <Link
                  to="/blogs"
                  className="w-full rounded-md border border-green-500 bg-green-500 py-2 px-6 text-white transition hover:border-green-600 hover:bg-green-600 sm:max-w-max"
                >
                  <i className="fa-brands fa-readme"></i> Read More
                </Link>
                <Link
                  to="/write-blog"
                  className="w-full ml-5 rounded-md border border-indigo-500 bg-indigo-500 py-2 px-6 text-white transition hover:border-indigo-600 hover:bg-indigo-600 sm:max-w-max"
                >
                  <i className="fa-solid fa-pen-nib"></i> Write
                </Link>
              </div>
            ) : (
              <Link
                to="/signin"
                className="w-full rounded-md border border-blue-500 bg-blue-500 py-2 px-6 text-white transition hover:border-blue-600 hover:bg-blue-600  sm:max-w-max"
              >
                Sign In
              </Link>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default HomeCarousel;
